import { IDTT_GET, IDTT_SET } from "../actions/action-types";
import { initialSTateDatasData, initialStateNext } from "../helpers";

// Sauvegarder l'identité
export function SaveIdttReducer(state = initialStateNext, action) {
    switch (action.type) {
        case IDTT_SET:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Obtenir l'identité
export function GetIdttReducer(state = initialSTateDatasData, action) {
    switch (action.type) {
        case IDTT_GET:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}